// create pipe that returns a string with tiers prenom and nom and nom marital

import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'displayTitle'
})
export class DisplayTitlePipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        let title: string = ''
        let hasNomMarital: boolean = false
        // title format  NOMMARITAL PRENOM  if(HASNOMMARITAL) né(e) AABRAAM2 
        if (value) {
            if (value.NOMMARITAL) {
                hasNomMarital = true
                title += value.NOMMARITAL + ' '
            }
            if (value.PRENOM) {
                title += value.PRENOM + ' '
            }
            if (value.NOM) {
                if (hasNomMarital) {
                    title += 'né(e) '
                } else {
                    title += ' '
                }
                title += value.NOM
            }
        }
        return title
    }
}